<template lang="pug">
div
  section.u-mt-md
    AppTitle(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec3')" tag="h2")

      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec3Items')")
            h4 {{item.title}}
            p {{item.desc}}
        AppLink(:to="$t('sec3CtaUrl')" :title="$t('sec3Cta')" class="button-link is-small ") {{$t('sec3Cta')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec4')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec4Items')")
            h4 {{item.title}}
            p.u-mb-ts {{item.desc}}
            AppLink(v-if="item.url" :to="item.url" :title="$t('learnMore')" class="button-link is-small") {{$t('learnMore')}}


  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat type design",
    "pageDesc":"We design custom and variable fonts that come in all weights, languages and sizes to fit with your brand identity.",
    "mantra":"Designing type, |beautifully.",
    "mantraDesc":"Creating custom fonts that comes in all weights, sizes and languages. Type design comes to complete the cycle for your brand identity and support business by creating a unified experience for your end users.",
    "sec1":"Creating fonts in a strategic manner.",
    "sec1Items":{
      "1":{
        "title":"Research",
        "desc":"Analyzing the different typefaces through SWOT that helps us discover enhancement opportunities."
      },
      "2":{
        "title":"Design",
        "desc":"Achieving the legibility and readability standards by considering the font kerning, … and other standards."
      },
      "3":{
        "title":"Programming",
        "desc":"Turning the planned font into a real and tangible product through applying the equations and coding every letter."
      },
      "4":{
        "title":"Testing and iteration",
        "desc":"Testing the font scalability and trying even the smallest sizes in order to ensure functionality combined with aesthetics."
      }
    },
    "sec2":"Type wherever you want.",
    "sec2Items":{
      "1":{
        "title":"Online",
        "desc":"Whether its an App, website, software or even an operating system, get easily recognized by your brand custom font that completes your overall look and feeling. "
      },
      "2":{
        "title":"Print",
        "desc":"Pass your brand identity to publications through fonts that work with magazines, newspapers and provides a different reading experience."
      }
    },
    "sec3":"We create custom fonts that scale with your needs",
    "sec3Cta":"Explore Baianat fonts library",
    "sec3CtaUrl":"/",
    "sec3Items":{
      "1":{
        "title":"Variable fonts",
        "desc":"Add richness to your brand with a custom font that scales, adapts and becomes part of your visual design language."
      },
      "2":{
        "title":"Global Languages",
        "desc":"We help global brands keep consistency by tailoring fonts that fit with their overall brand identity across different languages."
      }
    },
    "sec4":"Express your identity with custom letters.",
    "sec4Items":{
      "1":{
        "title":"Calligraphy",
        "desc":"Get a personal style with calligraphy. Handwritten letter by letter to give you an artistic look needed to stand out.",
        "url":"/services/calligraphy"
      },
      "2":{
        "title":"Editorial design",
        "desc":"Turning letters and words into graphic masterpieces by combining typography and images in unique layouts to express your brand.",
        "url":"/services/editorial-design"
      }
    },
    "cta":"Get your future <br> font now."
  },
  "ar": {
    "pageTitle":"تصميم الخطوط",
    "pageDesc":"نصمم خطوط مخصصة وقابلة للتغيير، تأتي في جميع الأوزان، واللغات، والأحجام لتتناسب مع روح هويتك التجارية.",
    "mantra":"أكمل روح هويتك من |خلال تصميم الخطوط.",
    "mantraDesc":"نصمم خطوط مخصصة تأتي في جميع الأوزان، والأحجام، واللغات. تمنح تصميم الخطوط هويتك التجارية الشكل المناسب لها، وتدعم عملك التجاري من خلال تجربة موحدة يستمتع بها المستخدمين النهائيين.",
    "sec1":"صمم الخطوط بطريقة استراتيجية.",
    "sec1Items":{
      "1":{
        "title":"البحث",
        "desc":"نحلل جميع الخطوط من خلال تحليل سوات SWOT؛ الذي يمنحنا القدرة على اكتشاف المزيد من الفرص الممكنة لتحسين الخطوط المصصمة."
      },
      "2":{
        "title":"التصميم",
        "desc":"نسعى لتحقيق معايير سهولة ووضوح القراءة من خلال الاهتمام بتقنية font kerning…. وغيرها من المعايير."
      },
      "3":{
        "title":"البرمجة",
        "desc":"نحول الخط الذي تم تصميمه وفقًا للاستراتيجية  إلى منتج حقيقي من خلال تطبيق المعادلات والأكواد في كل حرف."
      },
      "4":{
        "title":"الاختبار والمراجعة",
        "desc":"نختبر قابلية تغيير الأحجام، ونجرب حتى أصغر خط يمكن تصميمه من أجل ضمان ترابط وظيفية الخط مع شكله الجمالي."
      }
    },
    "sec2":"اكتب أينما تريد.",
    "sec2Items":{
      "1":{
        "title":"أونلاين",
        "desc":"سواء كنت تمتلك موقعًا أو تطبيقًا أو برنامجًا أو حتى نظام تشغيل، اجعل من السهل التعرف على علامتك التجارية من خلال تصميم خط مخصص مناسب لها الذي يمنح عملائك مظهرًا وانطباعًا فريدًا. "
      },
      "2":{
        "title":"المطبوعات",
        "desc":"وسع من انتشار هويتك التجارية من خلال المطبوعات المختلفة مثل الصحف والمجلات، وقدم تجربة قراءة مميزة لعملائك من خلال خط مخصص يعبر عن روح هويتك التجارية."
      }
    },
    "sec3":"قم بإنشاء خطوط مخصصة تتناسب مع احتياجاتك.",
    "sec3Cta":"استكشف مكتبة خطوط بيانات",
    "sec3CtaUrl":"/",
    "sec3Items":{
      "1":{
        "title":"خطوط متنوعة",
        "desc":"امنح علامتك التجارية المزيد من التفرد من خلال خط مخصص يمكنه التكيف وتعديل حجمه، ويصبح جزءًا فعالًا في لغة تصميمك البصري."
      },
      "2":{
        "title":"اللغات العالمية",
        "desc":"نساعد العلامات التجارية العالمية في الحفاظ على التناسق من خلال تصميم الخطوط التي تتناسب مع هوية علامتها التجارية عبر اللغات المختلفة."
      }
    },
    "sec4":"عبر عن هويتك بحروف مخصصة.",
    "sec4Items":{
      "1":{
        "title":"الكاليجرافي",
        "desc":"احصل على أسلوبك الشخصي مع فن الخط. وكأنها حروف مكتوبة بخط اليد لتمنحك نظرة فنية بارزة وتعبر عن هويتك.",
        "url":"/services/calligraphy"
      },
      "2":{
        "title":"التصميم التحريري",
        "desc":"نعمل على تحويل الحروف والكلمات إلى روائع رسومية من خلال الجمع بين التايبوجرافي والصور في تخطيطات فريدة تعبر عن علامتك التجارية.",
        "url":"/services/editorial-design"
      }
    },
    "cta":"صمم الخط المناسب <br> لهويتك التجارية."
  }
}
</i18n>
